import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=aee53e82&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenu.vue?vue&type=style&index=0&id=aee53e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee53e82",
  null
  
)

export default component.exports